export interface Translation {
  [key: string]: string;
  language: SupportedLanguage;
}

export enum SupportedLanguage {
  Arabic = 'ar',
  English = 'en',
}
